// GAVION call-brief-pipeline: the pre-call brief.
export const callBriefEn = {
  card: {
    title: "Before the call",
    what_they_do: "What they do",
    hook: "Opener",
    history: "History",
    preparing: "Preparing…",
    unavailable: "Brief unavailable",
    // GAVION ops-lookup
    ops_contact: "Head of operations",
    ops_searching: "Searching…",
    ops_not_found: "Not found — ask the front desk who handles operations",
    ops_unknown: "Not searched yet — ask the front desk who handles operations",
    ops_not_searched:
      "No automatic search for this company — ask the front desk who handles operations",
    ops_source: "source",
    ops_manual: "entered by hand",
    ops_add_contact: "Add as contact",
    ops_contact_exists: "Already in contacts",
    ops_contact_added: "Contact added",
    ops_contact_failed: "The contact could not be added. Try again.",
    ops_contact_note: "Found by AI — source %{url}",
  },
  timeline: { title: "Brief" },
  settings: {
    title: "Pre-call brief",
    hint: "Three lines at the top of the lead (« What they do », « Opener », « History »), prepared in advance for the lead shown and the next 3 in the list. The first two are written by AI (Claude Haiku 5.5, about 0.03 ¢ per brief, kept 30 days).",
    enabled: "Pre-call brief",
    cap: "Daily brief limit",
    cap_hint:
      "The most AI briefs written per day, for the whole team (0 to 5000). « History » still shows.",
    cap_invalid: "Enter a whole number from 0 to 5000.",
    // GAVION ops-lookup
    ops_cap: "Daily « Head of operations » search limit",
    ops_cap_hint:
      "Companies looked up per day for the whole team (up to 3 web searches each; 0 to 5000, 0 = off): once per company, about 3 ¢ each (Claude Haiku 5.5). The name is kept only when a public source states it.",
    save: "Save",
    saved: "Brief settings saved.",
    save_failed: "The brief settings could not be saved. Try again.",
  },
  history: {
    first_call: "First call",
    attempt: "Call #%{n}",
    last: "%{outcome}, %{date}",
    note: 'Note: "%{text}"',
    callback: "Callback requested: %{date}",
  },
};
